import React from 'react';
import { Button, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type FormActionButtonsProps = {};

export const FormActionButtons: React.FC<FormActionButtonsProps> = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  return (
    <Grid container justifyContent="flex-end" spacing={2} mt={2}>
      <Grid item>
        <Button variant={'outlined'} onClick={() => navigate(-1)}>
          {t('cancel')}
        </Button>
      </Grid>
      <Grid item>
        <Button type="submit" variant={'contained'}>
          {t('create')}
        </Button>
      </Grid>
    </Grid>
  );
};
